export default "__VITE_ASSET__CfvD$NX8__"